<template>
  <div class="SellReportPage page">
    <div class="page-title">
      <span>{{('Product Report')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
          <option
            v-for="rate in (getCurrencyRates)"
            :value="rate.toCurrency"
            :key="rate.id"
          >
          {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" @onChangeProductType="onChangeProductType" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <UiReportList :reportList="reportList" />
    <div class="top-chart">
      <div class="dropdown-wrap">
        <select name="outlet" v-model="catalogId" @change="onChangeCatalog">
          <option :value="null">{{ $t("all_category") }}</option>
          <option :value="'Uncategorized'">{{ $t("Uncategorized") }}</option>
          <option v-for="catalog in getListCatalog" :key="catalog.id" :value="catalog.id">{{ catalog.name }}</option>
        </select>
      </div>
      <div class="checkbox">
        <input type="checkbox" id="checkbox" v-model="checkWithoutVariant" @change="onChangeVariant"/>
        <label for="checkbox">{{ $t("show_products_without_variant") }}</label>
      </div>
    </div>
    <div v-if="!isLoadingProductSoldChart && productSoldChart && productSoldChart.length > 0">
      <UiHighCharts :options="prepareChartOptions()" :noConvertDate="true" :loading="isLoadingProductSoldChart"></UiHighCharts>
    </div>
    <UiTableReportCommon :report="productReportData" :colsData="visibleFields" :typeGetData="typeGetData" :showPagination="true" :key="tableKey"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import UiReportList from '@/components/UiReportList'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import reportType from '@/config/reportType'
import reportList from '@/constants/reportList'
import UiHighCharts from '@/components/UiHighCharts'
import i18n from '@/i18n'
export default {
  name: 'ProductSoldPage',
  components: {
    UiFilterbar,
    UiReportList,
    UiTableReportCommon,
    UiHighCharts
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        productCategoryId: null,
        timeZone,
        reportingMode: 'in_store'
      },
      reportList: reportList.products,
      filterType: 'DATE',
      catalogId: null,
      type: 'products',
      fields: [
        { key: 'name', label: 'product_title', visible: true },
        { key: 'sku', label: 'sku', visible: true },
        { key: 'additionalData', label: 'variants', visible: true },
        { key: 'totalQtySold', label: 'total_quantity_sold', visible: true },
        { key: 'totalQtyRefund', label: 'quantity_refund', visible: true },
        { key: 'netQtySold', label: 'net_quantity_sold', visible: true }
      ],
      loaded: true,
      checkWithoutVariant: false,
      dataProductWithoutVariant: [],
      productListChart: [],
      valueChart: [],
      productWithoutVariantChart: [],
      valueWithoutVariantChart: [],
      countUpdate: 0,
      checkWithoutVariant2: false,
      productReportData: {},
      tableKey: 0
    }
  },
  watch: {
    getListOutLet: function (val) {
      this.outletItem = this.getQuery.outletId || null
    },
    productSoldChart: function (news, old) {
      const arrayProductClone = (news || []).map(u => ({ ...u, approved: true }))
      this.dataProductWithoutVariant = Object.values((arrayProductClone).reduce((acc, el) => {
        const uniqueKey = el.sku || el.name || ''
        if (!acc[uniqueKey]) {
          acc[uniqueKey] = el
        } else {
          acc[uniqueKey].totalQtySold += el.totalQtySold
        }
        return acc
      }, {}))
      this.productListChart = news ? news.map(item => item.name) : []
      this.valueChart = news ? news.map(item => item.totalQtySold || 0) : []
      this.productWithoutVariantChart = this.dataProductWithoutVariant.map(item => item.name)
      this.valueWithoutVariantChart = this.dataProductWithoutVariant.map(item => item.totalQtySold || 0)
    },
    reportQuery: function (news, old) {
      const omit = (prop, { [prop]: _, ...rest }) => rest
      if (news != null && old != null && JSON.stringify(omit('page', news)) !== JSON.stringify(omit('page', old))) {
        this.checkWithoutVariant = false
      }
      if (news?.productCategoryId !== old?.productCategoryId) {
        this.catalogId = news.productCategoryId
      }
    },
    checkWithoutVariant: function () {
      this.countUpdate = 0
    },
    productReport: function () {
      this.productReportData = this.productReport
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      reportQuery: 'report/getQuery',
      productReport: 'report/getProductReportData',
      getListCatalog: 'catalog/getListCatalog',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates',
      productSoldChart: 'report/getProductSoldChart',
      isLoadingProductSoldChart: 'report/getLoadingProductSoldChart'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    },
    typeGetData () {
      return reportType.productSold
    }
  },
  updated () {
    const catalog = this.getListCatalog.find((catalog) => catalog.id === this.catalogId)
    if (!catalog && this.catalogId !== 'Uncategorized') {
      this.catalogId = null
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getCatalog: 'catalog/getListCatalogByOulet',
      getProductChart: 'report/getProductSoldSumStore',
      setLoadingProductChart: 'report/setLoadingProductChart',
      resetQueryReport: 'report/resetQueryReport'
    }),
    selectCurrency () {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }
      
      this.getReport({
        type: reportType.productSold,
        query: {
          ...this.query,
          ...this.day
        }
      }).then(() => {
        this.productReportData = this.productReport
      })
      this.getProductChart({
        type: reportType.productSold,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses, productTypes) {
      this.query.states = states
      this.query.statuses = statuses
      this.query.productTypes = productTypes
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.productSold,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          productTypes
        }
      }).then(() => {
        this.productReportData = this.productReport
      })
      this.getProductChart({
        query: {
          ...this.query,
          ...day,
          limit: 50,
          states,
          statuses,
          productTypes
        }
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds) {
      this.day = day
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.query.productCategoryId = null
      this.getReport({
        type: reportType.productSold,
        query: {
          ...this.query,
          ...day,
          productCategoryId: null
        }
      }).then(() => {
        this.productReportData = this.productReport
      })
      this.getProductChart({
        query: {
          ...this.query,
          limit: 50,
          ...day,
          productCategoryId: null
        }
      })
    },
    onChangeProductType (reportingMode, outletIds, registerIds, day, type, productTypes) {
      this.day = day
      this.query.productTypes = productTypes
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.productSold,
        query: {
          ...this.query,
          ...day,
          productTypes
        }
      }).then(() => {
        this.productReportData = this.productReport
      })
      this.getProductChart({
        query: {
          ...this.query,
          limit: 50,
          ...day,
          productTypes
        }
      })
    },
    onChangeCatalog () {
      this.query.productCategoryId = this.catalogId
      this.getReport({
        type: reportType.productSold,
        query: {
          ...this.reportQuery,
          page: 1,
          productCategoryId: this.catalogId === 'Uncategorized' ? 'uncategorized' : this.catalogId
        }
      }).then(() => {
        this.productReportData = this.productReport
      })
      this.getProductChart({
        type: reportType.productSold,
        query: {
          ...this.reportQuery,
          page: 1,
          limit: 50,
          productCategoryId: this.catalogId === 'Uncategorized' ? 'uncategorized' : this.catalogId
        }
      })
    },
    onChangeVariant () {
      this.tableKey = Math.random()
    },
    prepareChartOptions () {
      const productList = this.checkWithoutVariant ? this.productWithoutVariantChart : this.productListChart
      const valueList = this.checkWithoutVariant ? this.valueWithoutVariantChart : this.valueChart
      return {
        chart: {
          type: 'column',
          redraw: true,
          panning: true,
          reflow: false,
          animation: false
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          },
          series: {
            pointPadding: 0
          }
        },
        tooltip: {
          enabled: true,
          animation: false
        },
        series: [{
          name: i18n.t('net_quantity_sold'),
          data: valueList
        }],
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'category',
          categories: productList,
          min: 0,
          max: valueList?.length > 50 ? 50 : valueList?.length - 1,
          scrollbar: {
            enabled: true
          },
          tickLength: 0
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        }
      }
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  beforeRouteLeave(to, from, next) {
    this.resetQueryReport({
      type: reportType.productSold,
      query: {
        ...this.query,
        ...this.day,
        productCategoryId: null
      }
    })
    next()
  },
  created () {
    const currenStore = getItemByLocalStorage(localStorageKey.STORE_ID)
    const currenOutlets = JSON.parse(getItemByLocalStorage(localStorageKey.CURRENT_OUTLET_ID) || '[]')
    if ((this.getListCatalog || []).length < 1) {
      this.getCatalog(currenStore, currenOutlets)
    }
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
    .chart-wrapper {
      width: 100%;
      overflow: auto;
    }
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
  .top-chart {
    display: flex;
    .dropdown-wrap {
      margin-bottom: 15px;
      select {
        padding: 0 15px;
        margin: 0;
        height: 39px;
        min-width: 100px;
        outline: none;
        border-radius: 4px;
        border: 0;
        background-color: #fff;
      }
    }
    .checkbox {
      height: 39px;
      align-items: center;
      display: flex;
      margin-left: 40px;
      label {
        font-size: 13px;
      }
    }
  }
  .chart-wrapper {
    position: relative;
    .chart-loading {
      position: absolute;
      min-height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 48%;
      z-index: 100;
    }
  }
  
</style>
